import styled, { css } from '@eduzz/houston-styles';

export const Image = styled.img`
  opacity: 0.4;
  filter: grayscale(1);

  ${({ theme }) => css`
  @media only screen and (max-width: ${theme.breakpoints.md}) {
    width: 90%;
`}
`;
